
enum ModelName {
  "robot.UserCleaningZone" = "cleaning-zone",
  "robot.UserRedZone" = "red-zone",
  "robot.UserRuleZone" = "rule-zone",
  "robot.UserRepeatPathZone" = "teachandrepeat-zone",
  "robot.UserGate" = "gate",
  "robot.UserLandmark" = "maintenance-point",
  "robot.UserMission" = "mission-name-default",
  "robot.UserScheduling" = "schedule-entry",
  "robot.UserLimitZone" = "limit-zone",
  "robot.UserExcludedDate" = "no-go-date",
  "robot.UserFloor" = "label-room",
}


export default ModelName;